<template>
  <v-radio-group v-model="myValue" :dense="dense" style="margin-top:0">
    <template v-slot:label v-if="label">
      <div v-html="label"></div>
    </template>
    <template v-for="(_, scopedSlotName) in $scopedSlots" v-slot:[scopedSlotName]="slotData">
      <slot :name="scopedSlotName" v-bind="slotData"></slot>
    </template>
    <template v-for="(_, slotName) in $slots" v-slot:[slotName]>
      <slot :name="slotName"></slot>
    </template>
    <template v-for="(item, index) in items">
      <v-radio :key="index" v-bind="item" :label="item.text" :disabled="disabled || item.disabled"></v-radio>
      <p v-if="item.subtext" :key="'text-' + index" style="margin:.5em 1em 1em 2em" v-html="item.subtext"></p>
    </template>
  </v-radio-group>
</template>
<style>
  div.v-input.v-input--radio-group.v-input--radio-group--column legend {
    display: block;
    min-height: 30px;
  }
</style>
<script>
import { ref, watch } from '@vue/composition-api'
export default {
  props: {
    value: {
      type: [String, Number],
      default: ''
    },
    items: {
      type: Array,
      required: true
    },
    label: String,
    dense: Boolean,
    disabled: {
      type: Boolean,
      default: false
    }
  },
  setup (props, { emit }) {
    const myValue = ref('')

    watch(() => props.value, (val) => {
      myValue.value = val
    })

    watch(myValue, (val) => {
      emit('input', val)
      emit('change', val)
    })

    return {
      myValue
    }
  }
}
</script>
